import {
    KontentMedia,
    BrandColor,
    KontentRadioMultiChoice,
    KontentIcon,
    Statement,
    CTAConfiguration,
    CTALocation,
    KontentStringValue,
} from '../../../../types/KontentProps';
import { BuildLinkHref } from '../BuildLinkHref';
import { BlogPagePreview } from './blogQueries';
// @ts-ignore
import localIcons from '../../../global/localIcons.json';

export interface MediaData {
    name: string;
    description: string;
    url: string;
    width?: number;
    height?: number;
}

export function getMediaData(data: KontentMedia | undefined): MediaData | null {
    if (
        !data?.value?.length ||
        !data?.value[0]?.elements?.file?.value[0]?.url
    ) {
        return null;
    }

    const file = data.value[0].elements.file.value[0];
    return {
        name: file.name,
        description: file.description,
        url: file.url,
        width: file.width,
        height: file.height,
    };
}

export {
    imagePreset,
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    normalizeKontentImageParams,
    isKontentWebpSource,
    getDisplayDimensions,
} from './kontentImageOptimization';
export type { KontentImageParams } from './kontentImageOptimization';

export function getColor(data: BrandColor | undefined): string | null {
    if (
        !data?.value?.length ||
        !data?.value[0]?.elements?.color_hex_value?.value
    ) {
        return '';
    }

    return `#${data.value[0]?.elements.color_hex_value.value}`;
}

export function getMultiChoice(data: KontentRadioMultiChoice<any> | undefined) {
    return data?.value[0]?.codename || null;
}

export function getIcon(data: KontentIcon | undefined) {
    return {
        url: data?.value[0]?.elements?.icon_svg_file?.value[0]?.url,
        description:
            data?.value[0]?.elements?.icon_svg_file?.value[0]?.description,
        name: data?.value[0]?.elements?.wellness_type?.value?.name,
    };
}

const KONTENT_ASSET_ID =
    /kc-usercontent\.com(?::\d+)?\/[^/]+\/([0-9a-f-]{36})\//;

/**
 * Returns the build-time WebP copy of a Kontent asset when one exists
 * (generated by scripts/build-local-icons.js), otherwise the original URL.
 */
export function localIconUrl(url: string | undefined) {
    const assetId = url?.match(KONTENT_ASSET_ID)?.[1];
    return (assetId && (localIcons as Record<string, string>)[assetId]) || url;
}

/** getIcon, served from the build when the asset has a local copy. */
export function getLocalIcon(data: KontentIcon | undefined) {
    const icon = getIcon(data);
    return { ...icon, url: localIconUrl(icon.url) };
}

export function getStatement(statement: Statement) {
    return {
        displayTitle: statement.elements?.display_title,
        richDescription: statement.elements?.rich_description,
        icon: getIcon(statement.elements?.icon),
        style: getMultiChoice(statement.elements?.style),
        displayTitleColor: getColor(statement.elements?.display_title_color),
    };
}

export function getTimeToRead(page: BlogPagePreview) {
    const combinedMinutesToRead = page.elements.page_components.value.map(
        (component) => {
            if (component?.system?.type === 'component___blog_content') {
                return component?.readingTime.minutes;
            }

            return 0;
        }
    );

    const sumMinutesToRead = combinedMinutesToRead.reduce((a, b) => a + b, 0);

    return Math.ceil(sumMinutesToRead);
}
